import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Закрывает раскрытое меню при клике мимо него.
//
// Bootstrap сам сворачивает меню только по кнопке-бургеру: чтобы убрать его с
// экрана, приходилось целиться обратно в иконку. Клик в любое свободное место —
// привычное поведение и попадать никуда не надо.
export default class extends Controller {
  static targets = ["menu"]

  closeOnOutsideClick(event) {
    if (this.element.contains(event.target)) return

    this.close()
  }

  // Пункт выбран — меню больше не нужно. Turbo подменяет страницу целиком, но
  // при переходе внутри той же страницы меню осталось бы висеть.
  closeOnSelect() {
    this.close()
  }

  close() {
    if (!this.hasMenuTarget) return
    if (!this.menuTarget.classList.contains("show")) return

    bootstrap.Collapse.getOrCreateInstance(this.menuTarget).hide()
  }
}
